export const site = {
  name: "网曝吃瓜",
  fullName: "网曝吃瓜 · 网友爆料投稿聚集地",
  tagline: "投稿、素材、线索、原帖，一站围观",
  slogan: "让每一条线索都有出处，让每一次围观都有信息量",
  intro:
    "网曝吃瓜是一个以网友投稿为核心的内容聚合站。我们把散落在各处的爆料素材、围观线索与原帖信息整理成可读的条目，配上来源标注与时间线，让热点事件从「听说」变成「看得明白」。",
  email: "hello@wangbaochigua.example",
  tipEmail: "tips@wangbaochigua.example",
  since: "2021",
  stats: [
    { label: "累计整理投稿", value: "128,600+" },
    { label: "在架线索条目", value: "3,240" },
    { label: "活跃投稿用户", value: "46,800" },
    { label: "平均核实耗时", value: "4.2 小时" },
  ],
  hotWords: [
    "选秀赛制",
    "带货翻车",
    "路透造型",
    "电梯广告",
    "联名补货",
    "探店踩点",
    "片场花絮",
    "预约规则",
    "宣传语撞梗",
    "时间线梳理",
  ],
  principles: [
    {
      icon: "ri-shield-check-line",
      title: "来源可溯",
      desc: "每一条投稿都会标注投稿时间、投稿方式与可核实程度，不做无出处的转述。",
    },
    {
      icon: "ri-scales-3-line",
      title: "多方求证",
      desc: "涉及当事双方的线索，我们尽量并列呈现不同说法，不用单方叙述替代全貌。",
    },
    {
      icon: "ri-emotion-happy-line",
      title: "理性围观",
      desc: "拒绝人身攻击与未经证实的指控，只讨论事件本身与可公开核对的细节。",
    },
    {
      icon: "ri-time-line",
      title: "持续跟进",
      desc: "事件有新进展时，我们会在原条目上追加更新，保留完整的时间线脉络。",
    },
  ],
  carousel: [
    {
      title: "匿名投稿也能留痕",
      desc: "担心暴露身份？投稿时可以只留下昵称，我们只在编辑部内部保留可核实的联系方式。",
    },
    {
      title: "素材不裁剪不拼接",
      desc: "视频、截图类素材我们会保留原始比例与关键帧，避免因二次编辑产生新的误会。",
    },
    {
      title: "被误伤可以申诉",
      desc: "如果你认为某条内容与你相关且存在偏差，可以通过邮箱提交说明，我们会在核实后修正。",
    },
  ],
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "娱乐热议", to: "/category/entertainment" },
  { label: "网红动态", to: "/category/influencer" },
  { label: "影视综料", to: "/category/screens" },
  { label: "社会观察", to: "/category/society" },
  { label: "品牌公关", to: "/category/brand" },
  { label: "投稿精选", to: "/category/picks" },
];

export const footerGroups = [
  {
    title: "热门栏目",
    links: [
      { label: "娱乐热议", to: "/category/entertainment" },
      { label: "网红动态", to: "/category/influencer" },
      { label: "影视综料", to: "/category/screens" },
      { label: "社会观察", to: "/category/society" },
    ],
  },
  {
    title: "关于平台",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "我要投稿", to: "/submit" },
      { label: "内容原则", to: "/about" },
      { label: "联系编辑部", to: "/about" },
    ],
  },
  {
    title: "内容聚合",
    links: [
      { label: "品牌公关", to: "/category/brand" },
      { label: "投稿精选", to: "/category/picks" },
      { label: "全部条目", to: "/category/all" },
      { label: "编辑推荐", to: "/category/picks" },
    ],
  },
];